export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13640.9f6cc4ea.jpg";